import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EVALIDATOR_COMPLETED } from '@app/core/enums/customer.enum';
import { ICustomerValidate } from '@app/core/models/customer.model';

@Component({
  selector: 'layout-kyc-status-rejected-by-offer',
  templateUrl: './kyc-status-rejected-by-offer.component.html',
  styleUrls: ['./kyc-status-rejected-by-offer.component.scss'],
})
export class KycStatusRejectedByOfferComponent implements OnInit {
  @Input() validation: ICustomerValidate;
  @Input() isLoading: boolean;
  @Output() killPurchaseEvent = new EventEmitter<boolean>();
  @Output() visitRecordEvent = new EventEmitter<boolean>();
  @Output() returnToPersonalInfo = new EventEmitter<boolean>();

  public VALIDATOR = EVALIDATOR_COMPLETED;

  constructor() {}

  ngOnInit(): void {
    this.visitRecordEvent.emit(true);
  }

  public onKillPurchase() {
    this.killPurchaseEvent.emit(true);
  }

  public onReturnToPersonalInfo() {
    this.returnToPersonalInfo.emit(true);
  }
}
